import { Typography } from '@hmsexp/component-library';
import React, { useCallback, useState } from 'react';
import { View } from 'react-native';
import GridLayout from '../../../../components/GridLayout';
import { useSelector } from 'react-redux';
import OverviewLoader from './OverviewLoader';
import TopBottomProperties from './components/TopBottomProperties';
import SidebarComponent from './components/SidebarComponent';
import { get } from 'lodash';
import PieChartWidget from '../../../../components/Common/WidgetsCards/PieChartWidget';
import NetPromoterScoreWidget from '../../../../components/Common/WidgetsCards/PieChartWidget/NetPromoterScoreWidget';
import AdditionalMetricsComparisonWidget from './components/AdditionalMetricsComparisonWidget/index';
import TopAndBottomTopics from '../../../../components/Common/WidgetsCards/TopAndBottomTopics';
import { getChartExportsMenuItems } from '../../../../utils/common';

const OverviewComp = () => {
  const [openSideBar, setOpenSidebar] = useState(false);
  const [selectedCardData, setSelectedCardData] = useState({});
  const [selectedCardId, setSelectedCardId] = useState(null);

  function onChartClick(d, itemData) {
    if (!itemData?.disableChartClick) {
      setOpenSidebar(true);
      if (itemData?.dialClickPageType) {
        setSelectedCardId(itemData?.dialClickPageType);
      }
      setSelectedCardData(itemData);
    }

  }
  const {
    isFetchingOverviewData,
    overViewData = [],
    OverviewDataFetchingError
  } = useSelector(e => e.fetchOverviewDataReducer);
  

  const { applied_filters, applied_filter_values, filtersLoading } = useSelector(e => e.filterReducer);
  const timeperiodLabel = get(applied_filters, 'timePeriod[0].fullLabel', 'Last 90 days');

  const renderItem = useCallback(({ item }) => {
    switch (item.type) {
      case 'TEXT_HEADER':
        return <Typography {...get(item, 'data.typographyProps')}>{get(item, 'data.title')}</Typography>;
      case 'PIE_CHART':
        return <PieChartWidget actionMenuData={getChartExportsMenuItems(item)} onChartClick={onChartClick} item={item} timeperiodLabel={timeperiodLabel} />
      case 'NET_PROMOTER_SCORE':
        return <NetPromoterScoreWidget actionMenuData={getChartExportsMenuItems(item)} onChartClick={onChartClick} item={item} timeperiodLabel={timeperiodLabel} />
      case 'ADDITIONAL_METRICS_COMPARISON_CHART':
        return <AdditionalMetricsComparisonWidget actionMenuData={getChartExportsMenuItems(item)} item={item} timeperiodLabel={timeperiodLabel} />
      case 'TOP_BOTTOM_TOPICS':
        return <TopAndBottomTopics applied_filter_values={applied_filter_values} item={{ ...item, subTitle: timeperiodLabel }} />
      case 'BOTTOM_5_PROPERTIES':
      case 'TOP_5_PROPERTIES':
        return (
          <TopBottomProperties actionMenuData={getChartExportsMenuItems(item)} item={item} timeperiodLabel={timeperiodLabel} />
        );
      default:
        return null;
    }
  }, [timeperiodLabel]);

  const renderContent = useCallback(() => {
    if (isFetchingOverviewData || filtersLoading) {
      return <OverviewLoader />;
    }
    return <GridLayout gap={30} data={overViewData?.filter(e => e.isVisible)} renderItem={renderItem} />;
    // return <GridLayout gap={30} data={OVERVIEW_WIDGET_DATA} renderItem={renderItem} />;
  }, [isFetchingOverviewData, filtersLoading, overViewData]);

  return (
    <View style={{ padding: 20 }}>
      <SidebarComponent
        selectedCardId={selectedCardId}
        setSelectedCardId={setSelectedCardId}
        selectedCardData={selectedCardData}
        visible={openSideBar}
        onClose={() => setOpenSidebar(false)}
      />
      {renderContent()}
    </View>
  );
};
export default OverviewComp;